module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-douwe-egberts-03.1@2x.d0adc1a2.jpg";